import { Validation } from './rules/validation.interface';
import { Mask } from './rules/mask.interface';

export class InputModel {

  maskRule: (string | RegExp)[] | boolean | Function = false;

  isAuth: boolean;
  isMidleWidth: boolean;
  type: string;
  placeholder: string;
  validators: Validation[] = new Array<Validation>();
  mask: Mask;
  readOnly: boolean;
  isInputCurrencyRecharge: boolean;
  isInputCurrencyReembolso: boolean;
  isUpperCase: boolean;
  maxlength?: number;

  // tslint:disable-next-line:max-line-length
  constructor(_isAuth?: boolean, _isMidleWidth?: boolean, _type?: string, _placeholder?: string, _validators?: Validation[], _mask?: Mask, _maxlength?: number) {
    this.isAuth = _isAuth;
    this.isMidleWidth = _isMidleWidth;
    this.type = _type;
    this.placeholder = _placeholder;
    this.validators = _validators;
    this.mask = _mask;
    this.maxlength = _maxlength;
  }

  setReadOnly() {
    this.readOnly = true;
  }

  disableReadOnly() {
    this.readOnly = false;
  }

  setUpperCase() {
    this.isUpperCase = true;
  }

  setIsInputCurrencyRecharge() {
    this.isInputCurrencyRecharge = true;
  }

  setIsInputCurrencyReembolso() {
    this.isInputCurrencyReembolso = true;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/input/input.model.ts